import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { KmxContainer } from '../../../components/KmxContainer';
import { PrequalPromoCard } from '@kmx/finance-shared-react-components/prequal-promo-card';
import { PromoCard } from '@kmx/instant-offer-expatriate';
import { useMuiMediaQuery } from '../../../utilities/hooks/useMuiMediaQuery';
import { getEnvConfig } from '../../../utilities/environmentConfig';
import useAppState from '../../../common/state/appState';
import HomePageExperience from '../hero/store/HomePageExperience';
import { useEffect } from 'react';

const getIoBreakpoint = ({
    isMobile,
    isTablet,
    isReturnVisitor,
}: {
    isMobile: boolean;
    isTablet: boolean;
    isReturnVisitor: boolean;
}) => {
    if (isMobile) return 'sm';
    if (isTablet || isReturnVisitor) return 'lg';
    return 'xl';
};

const FinancePromosSection = () => {
    const { isTablet, isMobile } = useMuiMediaQuery();
    const { environment, baseUrl } = getEnvConfig();
    const experience = useAppState((state) => state.experience);
    const isReturnVisitor =
        experience === HomePageExperience.ReturnVisitor || experience === HomePageExperience.Transfer;
    const ioBreakpoint = getIoBreakpoint({ isMobile, isTablet, isReturnVisitor });

    useEffect(() => {
        const financePromos = document.getElementById('finance-promos');
        if (!financePromos) return;

        if (isReturnVisitor) {
            financePromos.classList.add('finance-promos--return-visitor');
        } else {
            financePromos.classList.remove('finance-promos--return-visitor');
        }
    }, [isReturnVisitor]);

    return (
        <KmxContainer
            component="section"
            maxWidth="xl"
            sx={{
                pt: isReturnVisitor ? { xs: 5, sm: 6 } : { xs: 0.5, sm: 2 },
            }}
        >
            <Stack spacing={2} useFlexGap direction={{ xs: 'column', lg: 'row' }}>
                <Box sx={{ flex: 1 }}>
                    <PromoCard baseUrl={baseUrl} breakpoint={ioBreakpoint} originPage="home" />
                </Box>
                {isReturnVisitor && (
                    <Box sx={{ flex: 1 }}>
                        <PrequalPromoCard
                            environment={environment}
                            adobeData={{ position: 'home page hero', originPage: 'HP_Promocard_FF' }}
                            size={isMobile ? 'small' : 'large'}
                        />
                    </Box>
                )}
            </Stack>
        </KmxContainer>
    );
};
export default FinancePromosSection;
